import axios from 'axios';
import React from 'react'
import { Button, Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { fetchCsrfCookie } from '../../../../../redux/action/csrf/csrf-cookie';

const DeleteModal = (props) => {
    const dispatch = useDispatch()
    const {t} = useTranslation();

    const handleDelete = () => {
        dispatch(fetchCsrfCookie())
        axios.delete(`admin/link/${props.id}`)
        .then(res => {
            toast.dismiss()	
            toast.success(t("toast_successfully_removed") , {position: 'bottom-right',className: 'foo-bar'})
            props.update()
        })
        .catch(err => {
            console.log(err);
            toast.dismiss()
            toast.error(t("toast_something_went_wrong") , {position: 'bottom-right',className: 'foo-bar'})
        })
    }

    return (
        <>
            {props.show && (
                <Modal show={props.show}>
                    <Modal.Header>
                        <Modal.Title>{t("delete this item")}</Modal.Title>
                    </Modal.Header>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={props.handleClick}>
                            {t("Cancel")}
                        </Button>
                        <Button variant="danger" onClick={handleDelete}>
                            {t("confirm")}
                        </Button>
                    </Modal.Footer>
                </Modal>
            )}
        </>
    )
}

export default DeleteModal
